<template>
    <a
        :class="`flex ${isLargeTile ? 'flex-col' : 'flex-row'} rounded-md overflow-hidden items-start no-underline border border-white hover:border-primary-dark shadow-small hover:shadow-primary-2xl transition-all duration-100`"
        :href="articleData.articleHref"
    >
        <div
            :class="`bg-cover ${isLargeTile ? ' w-full grow' : 'w-[122px] h-full'} relative bg-center shrink-0`"
            :style="{
                'background-color': `#${articleData.titleColor}`,
                'background-image': `url(${articleData.titlePictureUrl?.replace('.jpg', '-t.jpg')})`
            }"
        >
            <div v-if="articleData.isSponsored" class="absolute top-0 right-0">
                <div class="w-[22px] h-[22px] m-1 flex items-center justify-center rounded-full overflow-hidden">
                    <svg class="fill-yellow-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="#fff" /><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z" /></svg>
                </div>
            </div>
        </div>

        <div :class="`flex flex-col ${isLargeTile ? 'w-full' : 'h-full grow'} bg-surface font-medium min-h-[64px] p-2`">
            <div class="text-primary-dark break-normal overflow-clip">
                <div>{{ articleData.displayName }}</div>
            </div>

            <div class="text-secondary text-xs grow">
                {{ articleCreationDate }}
            </div>
        </div>
    </a>
</template>

<script setup>
    import { computed } from 'vue'
    import { fromUtc, nowInLatvia, dayjs } from '@/js/global/date-helpers'
    import relativeTime from 'dayjs/plugin/relativeTime'

    const props = defineProps({
        articleData: {
            type: Object,
            default: null
        },
        isLargeTile: {
            type: Boolean,
            default: false
        }
    })

    dayjs.extend(relativeTime)

    const articleCreationDate = computed(() => {
        const date = fromUtc(props.articleData.articleCreationDate).toLatviaTime()

        // Ja raksts ir vecāks par 10 dienām, tad rāda pilno datumu
        if (date.isBefore(nowInLatvia().subtract(10, 'day'))) {
            return date.format('DD.MM.YYYY.')
        }

        // Citādi rāda lokalizētu raksta vecuma tekstu
        return date.fromNow()
    })

</script>